module.exports = __webpack_public_path__ + "static/media/girl.7ecbc6b0.png";